import dayjs from 'dayjs';
import { IProductProcess } from 'app/shared/model/product-process.model';
import { ProcessType } from 'app/shared/model/enumerations/process-type.model';
import { StepType } from 'app/shared/model/enumerations/step-type.model';
import { StepStatus } from 'app/shared/model/enumerations/step-status.model';

export interface IProductProcessHistory {
  id?: number;
  processType?: keyof typeof ProcessType;
  stepType?: keyof typeof StepType;
  stepStatus?: keyof typeof StepStatus;
  retryCount?: number | null;
  payloadIn?: string | null;
  payloadOut?: string | null;
  coolingOffEnd?: dayjs.Dayjs | null;
  offerExpirationDate?: dayjs.Dayjs | null;
  mandateSignedDate?: dayjs.Dayjs | null;
  desiredDate?: dayjs.Dayjs | null;
  actualStartDate?: dayjs.Dayjs | null;
  transactionId?: string | null;
  waiveCoolingOffRight?: boolean | null;
  depositRequired?: boolean | null;
  deposit?: boolean | null;
  createdAt?: dayjs.Dayjs;
  productProcess?: IProductProcess | null;
}

export const defaultValue: Readonly<IProductProcessHistory> = {
  waiveCoolingOffRight: false,
  depositRequired: false,
  deposit: false,
};
